/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu, Checkbox, Badge, FlexCol } from 'sarsaparilla';

export default function StoryCategoryFilter2023({
    aggregations,
    selectedFilters,
    onApply,
}) {
    const [filters, setFilters] = useState([...selectedFilters]);

    function getCount(attribute) {
        if (aggregations) {
            return aggregations[attribute] || 0;
        }
        return 0;
    }

    // Find the total amounts
    const traditionsTotal = getCount('Traditions (Old and New)');
    const reflectionTotal = getCount('Reflection Journeys');
    const reachingTotal = getCount('Reaching for the Stars');
    const familyTotal = getCount('Family or Group Travel');
    const activitiesAdventureTotal = getCount('Activities & Adventure');

    const onFilterChange = (event) => {
        if (event.target.checked) {
            const newFilters = [...filters];
            newFilters.push(event.target.value);
            setFilters(newFilters);
        } else {
            setFilters(filters.filter((f) => f !== event.target.value));
        }
    };

    const onApplyClicked = () => {
        onApply(filters);
    };

    const id = 'ugc-story-filter';

    return (
        <FlexCol xs={12} md="variable" className="mr-0 mr-md-1 mr-lg-2 mb-2 mb-md-0">
            <DropdownMenu
                label="Story Type"
                id="ugc-story-type"
                badgeCount={selectedFilters.length === 0 ? null : selectedFilters.length}
                onApply={onApplyClicked}
                clickTagCategory="share-your-story"
                clickTagAction={`Filter by: ${filters}`}
                clickTagLabel="2022-story-type-filter"
            >
                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-traditions`}
                        label="Traditions (Old and New)"
                        value="Traditions (Old and New)"
                        isChecked={filters.includes('Traditions (Old and New)')}
                        isDisabled={traditionsTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{traditionsTotal}</Badge>
                </div>
                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-reflection-journeys`}
                        label="Reflection Journeys"
                        value="Reflection Journeys"
                        isChecked={filters.includes('Reflection Journeys')}
                        isDisabled={reflectionTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{reflectionTotal}</Badge>
                </div>
                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-reaching-for-the-stars`}
                        label="Reaching for the Stars"
                        value="Reaching for the Stars"
                        isChecked={filters.includes('Reaching for the Stars')}
                        isDisabled={reachingTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{reachingTotal}</Badge>
                </div>
                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-family-or-group-travel`}
                        label="Family or Group Travel"
                        value="Family or Group Travel"
                        isChecked={filters.includes('Family or Group Travel')}
                        isDisabled={familyTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{familyTotal}</Badge>
                </div>
                <div className="ugc-story-checkbox-wrap">
                    <Checkbox
                        id={`${id}-activities-and-adventure`}
                        label="Activities & Adventure"
                        value="Activities & Adventure"
                        isChecked={filters.includes('Activities & Adventure')}
                        isDisabled={activitiesAdventureTotal === 0}
                        onChange={onFilterChange}
                    />
                    <Badge>{activitiesAdventureTotal}</Badge>
                </div>
            </DropdownMenu>
        </FlexCol>
    );
}

StoryCategoryFilter2023.propTypes = {
    aggregations: PropTypes.object,
    selectedFilters: PropTypes.array,
    onApply: PropTypes.func,
};
